<template>
    <router-link :to="`/events/${event.id}`">
        <div
            class="px-6 py-2 border border-gray-100 rounded shadow-sm hover:shadow transition duration-150"
        >
            <div class="text-sm flex items-center justify-between">
                <span class="flex-1">{{ event.id }}</span>
                <span class="flex-1">{{ event.sender }}</span>
                <span class="flex-1">{{ event.toUserId }}</span>
                <span class="flex-1">{{ event.fromUserId }}</span>
                <span class="flex-1">{{ event.eventType }}</span>
                <span class="flex-1">{{ formatDate(event.readAt) }}</span>
                <span class="flex-1">{{ event.detailJson }}</span>
                <span class="flex-1">{{ formatDate(event.createdAt) }}</span>
            </div>
        </div>
    </router-link>
</template>

<script>
import { formatDistanceToNow } from 'date-fns'
export default {
    methods: {
        formatDate(dateStr) {
            //@Todo we don't have Date scalar yet in our graphql schema so need to parseInt the string
            try {
                return `${formatDistanceToNow(new Date(parseInt(dateStr)), {
                    addSuffix: true,
                })}`
            } catch (err) {
                return null
            }
        },
    },
    props: ['event'],
}
</script>
